import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import { CashFlowCategorySection } from './CashFlowCategorySection';

export const CashFlowSectionPicker = ({
  sectionResource,
  onEditItemClick,
}) => {
  return (
    <CashFlowCategorySection
      sectionResource={sectionResource}
      onEditItemClick={onEditItemClick}
    />
  );
};

CashFlowSectionPicker.defaultProps = {
  onEditItemClick: noop,
};

CashFlowSectionPicker.propTypes = {
  sectionResource: PropTypes.object.isRequired,
  onEditItemClick: PropTypes.func,
};
